import { render, staticRenderFns } from "./Forms.component.html?vue&type=template&id=bac8b0c8&"
import script from "./Forms.component.ts?vue&type=script&lang=ts&"
export * from "./Forms.component.ts?vue&type=script&lang=ts&"
import style0 from "./Forms.component.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports